import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useCopyResource = (onClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.COPY_RESOURCE],
    (data) => ApiService.copyResource(data),
    {
      onSuccess: () => {
        toast.success('Template copied successfully')
        queryClient.invalidateQueries(QUERY_KEY.GET_GROUP);
        onClose()
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useCopyResource